import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const WordingContainer = styled('div')`
  padding: 32px 0 20px 0;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    padding: 36px 0 22px 0;
  }
`

export const CustomButton = styled(Button)`
  ${({ productoLookAndFeel }) =>
    productoLookAndFeel
      ? `background-color: ${productoLookAndFeel?.colorBackgroundBotones} !important;
      border-color:${productoLookAndFeel?.colorBordeCaja} !important;`
      : ``}

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin-left: 0;
  }
`

export const ZonajobsPostularWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const CustomButtonForZonajobs = styled(CustomButton)`
  margin-top: 11px;
`

export const ZonajobsWordingContainer = styled('div')`
  padding-top: 0px;
`
